import styled, { css } from 'styled-components'

const designerCSS = css``

const developerCSS = css`
  .wallet_page_balance_wrapper {
    margin: 15px 0 !important;
  }
`

export const WalletBalancesCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
